import SearchCarousel from '../../interactives/Carousel/variant/SearchCarousel'

export default function ContentfulSearchCarousel({
  testId,
  indexName,
  title,
  ctaUrlLink,
  ctaUrlTarget,
  ctaLabel,
  scrollByAmount,
  type,
  topics,
  keywords,
  dateLowerRange,
  dateUpperRange,
  authors,
  featured,
  premium,
  webinarMemberAuthentication,
  memberBook,
  bookCategory,
  quickRead,
  elArticleType,
  totalLength = 0,
  isAutoShowingCta = false,
}) {
  if (!indexName) return null
  return (
    <SearchCarousel
      testId={testId}
      indexName={indexName}
      title={title}
      ctaTarget={ctaUrlTarget}
      ctaLink={ctaUrlLink}
      ctaLabel={ctaLabel}
      scrollByAmount={scrollByAmount}
      type={type}
      topics={topics}
      keywords={keywords}
      dateLowerRange={dateLowerRange}
      dateUpperRange={dateUpperRange}
      authors={authors}
      featured={featured}
      elArticleType={elArticleType}
      premium={premium}
      webinarMemberAuthentication={webinarMemberAuthentication}
      memberBook={memberBook}
      bookCategory={bookCategory}
      quickRead={quickRead}
      totalLength={totalLength}
      isAutoShowingCta={isAutoShowingCta}
    />
  )
}
